export const regex = {
    // 이름체크 (한글 or 영문)
    isKorEng: (str) =>{
        return regex.isKor(str)||regex.isEng(str);
    },
    // 이름체크 (한글)
    isKor: (str)=> {
        // var regexp = /^[ㄱ-ㅎ|가-힣|\s|\*]+$/;
        var regexp = /^[\u3131-\u314E|\uAC00-\uD7A3:|\s|\*]+$/;
        return regexp.test(str);
    },
    // 이름체크 (영어, 공백허용)
    isEng: (str)=> {
        var regexp = /^[a-z|A-Z|\s|\*]+$/;		 
        return regexp.test(str);
    },
    // 숫자체크
    isNum: (num)=> {
        var regexp = /^[0-9]*$/;
        return regexp.test(num);
    },
    isBirth: (birth)=>{
        var regexp = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/
        return regexp.test(birth);
    },
    isValidBirthday: (dateStr)=> {
        if(dateStr === undefined || dateStr == "" || dateStr == null){
            return false;
        }
        var year = Number(dateStr.substr(0,4));
        var month = Number(dateStr.substr(4,2));
        var day = Number(dateStr.substr(6,2));
        var today = new Date();
        var yearNow = today.getFullYear();
        
        // 연도의 경우 1900 보다 작거나 yearNow 보다 크다면 false 반환
        if (1900 > year || year > yearNow){ 
            return false; 
        } else if (month < 1 || month > 12) {
            return false; 
        } else if (day < 1 || day > 31) { 
            return false; 
        } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day==31) { 
            return false; 
        } else if (month == 2) { 
            var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)); 
            if (day>29 || (day==29 && !isleap)) { 
                return false;
            } else { 
                return true; 
            } //end of if (day>29 || (day==29 && !isleap)) 
        } else { 
            return true; 
        }//end of if
    },
    // 주민 및 외국인 등록번호 유효성 검사
    isValidRnNum: (ssn1, ssn2)=> {
        var rn = ssn1 + ssn2;
   
        // 13자리 숫자인지 확인
        if( rn.length !== 13 ){
            return false;
        }						
        
        // 검증값 합계
        var checkSum = 0;
        for(var i = 0; i < 12; i++){
            checkSum += ((rn.substr(i,1)>>0)*((i%8)+2));
        } 
        
        // 검증
        var modCheckSum = checkSum%11;    // 검증값 합계의 11의 나머지수
        var rrnMatch = (11-(modCheckSum))%10 == rn.substr(12,1);    // 주민번호 검증
        var frnMatch = (13-(modCheckSum))%10 == rn.substr(12,1);    // 외국인번호 검증
                    
        // 주민/외국인 여부 상관 없이 등록번호 검사 
        return rrnMatch || frnMatch;
    },
    // 주민 및 외국인등록번호 생년월일 변경
    convertBirthDay: (ssn1, ssn2)=> {
        var birthday = null;
   
        //생년월일 변환
        if(ssn2.indexOf('1')==0 || ssn2.indexOf('2')==0){
            birthday = '19' + ssn1;
        } else if (ssn2.indexOf('3')==0 || ssn2.indexOf('4')==0){
            birthday = '20' + ssn1;
        } else if (ssn2.indexOf('5')==0 || ssn2.indexOf('6')==0){
            birthday = '19' + ssn1;
        } else if (ssn2.indexOf('7')==0 || ssn2.indexOf('8')==0){
            birthday = '20' + ssn1;
        } 
        
        return birthday;
    },
}